import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ProjectModal from '../Modal/ProjectModal';
import { Button } from 'react-bootstrap';

function ProjectCard(
    {
        altText,
        imagePath,
        title,
        description,
        subtitle,
        team,
        tools,
        duration,
        storyhook,
        internalProjects
    }) {
    const [modalShow, setModalShow] = React.useState(false);
    
    return (
        <Card sx={{ maxWidth: 345, minHeight: 520}}>
        <CardMedia
            component="img"
            alt = {altText}
            height="170"
            image={imagePath}
            className='mb-2'
        />
        <CardContent>
            <Typography variant="h5" component="div">
                { title }
            </Typography>
            <Typography gutterBottom variant="h7" component="div">
                { subtitle }
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                { description }
            </Typography>
            </CardContent>
            <hr></hr>
        <CardActions sx={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>

            <Button variant="outline-secondary" onClick={() => setModalShow(true)}>
                Learn More
            </Button>

            <ProjectModal
                    title={title}
                    roles={subtitle}
                    team={team}
                    tools={tools}
                    duration={duration}
                    description={description}
                    storyhook={storyhook}
                    internalProjects={internalProjects}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            </CardActions>
      </Card>

    );
}

export default ProjectCard;